import { configureStore } from '@reduxjs/toolkit';
import { createWrapper } from 'next-redux-wrapper';
import { persistStore, persistReducer, createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import rootReducer from './rootReducer';
import { initialState } from './uiSettings/uiSettingsSlice';

const storeVersion = 6;
const migrations = {
  [storeVersion]: (state) => {
    const safeState = state ?? {};
    const uiSettings = safeState.uiSettings ?? {};

    return {
      ...safeState,
      uiSettings: {
        ...uiSettings,
        availabilityGrid: initialState.availabilityGrid,
      },
    };
  },
};

const persistConfig = {
  version: storeVersion,
  key: 'root-grids',
  storage,
  whitelist: ['uiSettings'],
  migrate: createMigrate(migrations, { debug: false }),
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const makeStore = () => {
  const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // Ignore these action types
          ignoredActions: ['persist/PERSIST'],
        },
      }),
  });
  store.__persistor = persistStore(store);
  return store;
};

export const wrapper = createWrapper(makeStore);

export * from './oauth/oauthSlice';
export * from './catalog/vehiclesSlice';
export * from './subscriptions/subscriptionsSlice';
export * from './bookings/bookingsSlice';
export * from './notifications/notificationsSlice';
export * from './layout/layoutSlice';
export * from './arnmAccidents/arnmAccidentsSlice';
export * from './arnmRepairs/arnmRepairsSlice';
export * from './arnmMaintenance/arnmMaintenanceSlice';
export * from './ebike/ebikeSlice';
export * from './uiSettings/uiSettingsSlice';
export * from './availabilityTable/availabilityTableSlice';
export * from './sellVehicles/sellVehiclesSlice';
export * from './communication/communicationSlice';
export * from './logistics/logisticsSlice';
export * from './sellRequests/sellRequestsSlice';
